<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M12 3L2 8.5V10.5L12 16L22 10.5V8.5L12 3Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path
    d="M6.5 11.25V15.25C6.5 15.25 8.75 17.5 12 17.5C15.25 17.5 17.5 15.25 17.5 15.25V11.25"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M22 8.5L12 14L2 8.5"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
</svg>
